import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function numberWithSpaces(x: number, float?: boolean) {
  if (!x) return "0";

  return x
    .toFixed(float ? 2 : 0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const formatDate = (date: Date | string) => {
  if (typeof date === "string") date = new Date(date);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} в ${hours}:${minutes}`;
};

export function arraysAreEqual(arr1: string[], arr2: string[]) {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);

  if (set1.size !== set2.size) return false;

  for (const item of set1) {
    if (!set2.has(item)) return false;
  }

  return true;
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout | null = null;

  return (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}

export const filterObjectKeys = <T extends object, K extends keyof T = never>(
  obj: T,
  keysToExclude: K[] = [],
) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([key, value]) =>
        value !== undefined &&
        value !== "" &&
        value !== null &&
        !keysToExclude.includes(key as K),
    ),
  ) as Omit<T, K>;
};

export const safeDivide = (numerator: number, denominator: number) => {
  if (denominator === 0) {
    return 0;
  }
  return numerator / denominator;
};
